<template>
  <font-awesome-icon icon="edit" size="2x" @click="handleClick" class="edit-button" />
  <!-- <div class="edit-button"></div> -->
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

library.add(faEdit);

export default {
  name: "EditButton",
  props: {
    id: Number
  },
  methods: {
    handleClick: function(evt) {
      evt.preventDefault();

      this.$emit("edit-button-clicked", this.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-button {
  --button-color: #eee;

  position: absolute;
  color: var(--button-color);
  background-color: var(--secondary-color);
  border-radius: 50%;
  padding: 7px;
  left: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/EditButton.vue